import { createBrowserRouter, Outlet, RouterProvider } from "react-router";
import Home from "../Pages/Home/Home";
import Feedback from "../Pages/Feedback/Feedback";
import Header from "../Components/Header/Header";
import Error404 from "../Pages/Error404/Error404";
import Dashboard from "../Pages/Admin/Dashboard/Dashboard";
import Login from "../Pages/Admin/Login/Login";
import PrivateRoute from "../Components/PrivateRoute/PrivateRoute";
import PublicRoute from "../Components/PublicRoute/PublicRoute";
import { useEffect } from "react";
import { getStorage } from "../Util/storageHelper";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../Redux/store";
import { logoutUser, verifyUser } from "../Redux/Auth/AuthActions";
import FullScreenLoader from "../Components/FullScreenLoader/FullScreenLoader";
import SearchLogs from "../Pages/Admin/SearchLogs/SearchLogs";
import AddJobLogs from "../Pages/Admin/AddJobLogs/AddJobLogs";
import EmailLogs from "../Pages/Admin/EmailLogs/EmailLogs";
import JhRoute from "../jh/mount/JhRoute";

function Routes() {
  const dispatch = useDispatch<AppDispatch>();
  const { token, user, verify_loading } = useSelector(
    (state: RootState) => state.auth
  );

  function Layout() {
    return (
      <>
        <Header />
        <Outlet />
      </>
    );
  }

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        { index: true, element: <Home /> },
        { path: "feedback/:token", element: <Feedback /> },
      ],
    },
    {
      path: "/admin/login",
      element: (
        <PublicRoute>
          <Login />
        </PublicRoute>
      ),
    },

    {
      path: "/admin",
      element: (
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      ),
    },

    {
      path: "/admin/email-logs",
      element: (
        <PrivateRoute>
          <EmailLogs />
        </PrivateRoute>
      ),
    },

    {
      path: "/admin/search-logs",
      element: (
        <PrivateRoute>
          <SearchLogs />
        </PrivateRoute>
      ),
    },
    {
      path: "/admin/job-list",
      element: (
        <PrivateRoute>
          <AddJobLogs />
        </PrivateRoute>
      ),
    },
    { path: "/jh/*", element: <JhRoute /> },
    { path: "*", element: <Error404 /> },
  ]);

  useEffect(() => {
    const userData = getStorage("userData");

    if (userData !== null && userData !== undefined) {
      if (token === null && user === null) {
        dispatch(verifyUser({ token: userData?.token }));
      }
    } else {
      dispatch(logoutUser());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (verify_loading) {
    return <FullScreenLoader />;
  }

  return <RouterProvider router={router} />;
}

export default Routes;
